import { PINTEREST_ACCOUNT_STATISTICS, PINTEREST_TOP_POSTS } from '../constants/actionTypes';

const INITIAL_STATE = { data: null, errors: null };

export default function pinterestAnalytics(state = INITIAL_STATE, action) {
    switch (action.type) {
        case PINTEREST_ACCOUNT_STATISTICS:
            return { ...state, data: action.payload.data, errors: null };
        case PINTEREST_TOP_POSTS:
            return { ...state, videosWithStats: action.payload.data, errors: null }
        default:
            return state;
    }
}